import { defineComponent as _defineComponent } from 'vue'
import { CardArticle } from '@kodadot1/brick'
import substack from '@/script/substack.json'

interface Articles {
  title: string
  description: string
  image: string
  link: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeaturedArticles',
  setup(__props) {

const articles: Articles[] = substack.post

return { __sfc: true,articles, CardArticle }
}

})